import { Button } from './button'
import { Badge } from './badge'
import { ChevronDown } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface BasicFiltersProps {
  title: string
  filters?: string[]
  onFilterChange?: (filter: string) => void
  activeFilter?: string
  showSeeAll?: boolean
  onSeeAll?: () => void
  seeAllHref?: string
}

export function BasicFilters({ 
  title, 
  filters = [], 
  onFilterChange, 
  activeFilter,
  showSeeAll = false,
  onSeeAll,
  seeAllHref
}: BasicFiltersProps) {
  const { t } = useTranslation('common')
  
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-3">
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        {filters.length > 0 && (
          <div className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground">Filter by translated language:</span>
            <div className="flex gap-2">
              {filters.map((filter) => (
                <Badge
                  key={filter}
                  variant={activeFilter === filter ? "default" : "secondary"}
                  className={`cursor-pointer transition-colors ${
                    activeFilter === filter 
                      ? "bg-primary text-primary-foreground" 
                      : "hover:bg-muted"
                  }`}
                  onClick={() => onFilterChange?.(filter)}
                >
                  {filter}
                </Badge>
              ))}
            </div>
          </div>
        )}
      </div>
      
      {showSeeAll && (seeAllHref || onSeeAll) && (
        seeAllHref ? (
          <Link
            to={seeAllHref}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-9 px-3 text-primary hover:text-primary/80 hover:bg-accent hover:text-accent-foreground"
          >
            {t('library.seeAllBooks')}
            <ChevronDown className="ml-1 h-4 w-4 rotate-[-90deg]" />
          </Link>
        ) : (
          <Button
            variant="ghost"
            size="sm"
            onClick={onSeeAll}
            className="text-primary hover:text-primary/80"
          >
            {t('library.seeAllBooks')}
            <ChevronDown className="ml-1 h-4 w-4 rotate-[-90deg]" />
          </Button>
        )
      )}
    </div>
  )
}
